import axios from "axios";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = {
  contact: (d) => axios.post(`${API}/contact`, d),
  booking: (d) => axios.post(`${API}/booking`, d),
  newsletter: (d) => axios.post(`${API}/newsletter`, d),
  giftCard: (d) => axios.post(`${API}/gift-card`, d),
  partner: (d) => axios.post(`${API}/partner`, d),
  events: () => axios.get(`${API}/events`),
};
